import { z } from 'zod';
import { FINANCIAL_PRODUCT } from '../constants';
import { requiredApplicationIdString } from '../helper';
import { repaymentTerms } from '../shared';
import { ApplicationFormStatus, CustomerType } from '../types';

export const baseApplicationStep = z.object({
  id: requiredApplicationIdString(),
  status: z.nativeEnum(ApplicationFormStatus),
  financialProductId: z.nativeEnum(FINANCIAL_PRODUCT),
  customerType: z.nativeEnum(CustomerType),
  relatedQuotesInput: z
    .array(
      z.object({
        id: z.string(),
        repaymentTerm: repaymentTerms,
      }),
    )
    .optional(),
});
